import type { Question, QuestionStimulus, QuestionType } from '@examflow/core';

/**
 * SIELE 考试等级 (基于 CEFR 标准)
 */
export enum SIELELevel {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
}

/**
 * SIELE 考试部分
 */
export enum SIELESection {
  /** 阅读理解 */
  READING = 'reading',
  /** 听力理解 */
  LISTENING = 'listening',
  /** 书面表达 */
  WRITING = 'writing',
  /** 口语表达 */
  SPEAKING = 'speaking',
}

/**
 * SIELE 题目扩展接口
 */
export interface SIELEQuestion extends Question {
  /** 对应的 SIELE 等级 */
  sieleLevel?: SIELELevel;
  /** 所属考试部分 */
  section?: SIELESection;
  /** 题目序号（在该部分中） */
  orderInSection?: number;
}

/**
 * SIELE 听力题目（single_choice + audio stimulus）
 */
export interface SIELEListeningQuestion extends SIELEQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'audio'>[];
  /** 音频URL */
  audioUrl: string;
  /** 音频播放次数限制 */
  maxPlayCount?: number;
  /** 音频时长（秒） */
  audioDuration?: number;
}

/**
 * SIELE 阅读题目（single_choice + passage stimulus）
 */
export interface SIELEReadingQuestion extends SIELEQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'passage'>[];
  /** 阅读材料 */
  passage: string;
  /** 材料来源 */
  source?: string;
}

/**
 * SIELE 分数与等级对照表
 */
export interface SIELEScoreMapping {
  level: SIELELevel;
  minScore: number;
  maxScore: number;
  cefrEquivalent: string;
  description: string;
}

/**
 * SIELE 考试结果
 */
export interface SIELEResult {
  /** 总分（0-1000分制） */
  totalScore: number;
  /** 等级 */
  level: SIELELevel;
  /** 各部分得分（每部分0-250分） */
  sectionScores: Record<SIELESection, number>;
  /** CEFR 等级 */
  cefrLevel: string;
  /** 详细评价 */
  evaluation: string;
}
